import { Badge, Select, Text, Tooltip } from '@radix-ui/themes';
import { Info } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getStageStatuses, getStatusColor } from '../common';

const BadgeDropdown = ({
  initStatus,
  onChange,
  className = '',
  editableStatus = true,
}: {
  initStatus: string;
  onChange: (value: { type: string; status: string }) => void;
  className: string;
  editableStatus: boolean;
}) => {
  const { t } = useTranslation();
  const stageStatuses = getStageStatuses(t);

  let initStatusValue = initStatus;
  if (!initStatusValue) initStatusValue = 'old_application';

  const [selected, setSelected] = useState(initStatusValue);

  useEffect(() => {
    setSelected(initStatusValue);
  }, [initStatus]);

  const setNew = (e: string) => {
    setSelected(e);
    onChange({ type: 'status-execute', status: e });
  };

  return (
    <div className={'BadgeDropdown ' + className}>
      <Select.Root size="2" value={selected} onValueChange={setNew} disabled={!editableStatus}>
        <Select.Trigger variant="ghost" radius="large" color="gray" className="m-0" />
        <Select.Content position="popper" variant="soft" color="gray">
          {stageStatuses.map((stage) => (
            <Select.Group key={`stage-${stage.name}`}>
              <Select.Label className="justify-between p-0" hidden={stage.show === false ? true : false}>
                <span>{t('badgeDropdown.setStatusLabel', { stageName: stage.name })}</span>
                {stage.tooltip && (
                  <Tooltip content={<Text size="3">{stage.tooltip}</Text>}>
                    <Info size={14} />
                  </Tooltip>
                )}
              </Select.Label>
              {stage.status.map((status) => (
                <Select.Item
                  value={status.id}
                  key={status.id}
                  hidden={stage.show === false ? true : status.show === false ? true : false}
                >
                  <Badge variant="soft" radius="large" color={getStatusColor(status.id)}>
                    {status.name}
                  </Badge>
                </Select.Item>
              ))}
            </Select.Group>
          ))}
        </Select.Content>
      </Select.Root>
    </div>
  );
};

export default BadgeDropdown;
